import { render, staticRenderFns } from "./EditLegacy.vue?vue&type=template&id=02a6a15a&scoped=true&"
import script from "./EditLegacy.vue?vue&type=script&lang=ts&"
export * from "./EditLegacy.vue?vue&type=script&lang=ts&"
import style0 from "./EditLegacy.vue?vue&type=style&index=0&id=02a6a15a&scoped=true&lang=css&"
import style1 from "./EditLegacy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a6a15a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VCardActions,VCardText,VFlex,VIcon})
